<template>
  <div v-show="isLogin" class="nav-bar">
    <div class="float_box">
      <a v-if="isCart" href="javascript:void(0)" class="shopping_car" @click="navigateTo('/shoppingCar')"></a>
      <a v-if="isHome" href="javascript:void(0)" class="home_1" @click="navigateTo('/home')"></a>
      <a v-if="isMine" href="javascript:void(0)" class="mine_1" :class="showCircle ? 'new' : ''" @click="navigateTo('/myCenter')"></a>
      <!-- <a v-if="!isHome" href="javascript:void(0)" class="attention_1" @click="choose"></a> -->
    </div>
  </div>
</template>

<script>
// import store from '../../store';
// import Cookies from 'js-cookie';
import { mapGetters } from 'vuex';
export default {
  name: 'NavBar',
  props: {
    isMine: {
      default() {
        return false;
      }
    },
    isHome: {
      default() {
        return false;
      }
    },
    isCart: {
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      // showFlag: false,
      // isMine: true,
      // isHome: true
    };
  },
  computed: {
    ...mapGetters(['isLogin', 'showCircle'])
  },
  watch: {
    // isLogin(v) {
    //   if (v) {
    //     this.showFlag = true;
    //   } else {
    //     this.showFlag = false;
    //   }
    // }
  },
  mounted() {
    // if (store.state.app.isLogin) {
    //   this.showFlag = true;
    // } else {
    //   this.showFlag = false;
    // }
    // if (this.$route.path === '/home') {
    //   this.isHome = false;
    // } else if (this.$route.path === '/myCenter' || this.$route.path === '/myNews' || this.$route.name === 'topic') {
    //   this.isMine = false;
    // } else {
    //   this.isHome = true;
    // }
  },
  methods: {
    navigateTo(path) {
      this.$router.push(path);
    },
    choose() {
      this.$_dialog.toogle();
    }
  }
};
</script>

<style lang="scss" scoped>
.float_box {
  position: fixed;
  left: 0;
  z-index: 2;
  height: 2rem;
  bottom: 3.5rem;
  background: #ffffff;
  border-top-right-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
  box-shadow: 0 0 0.5rem #d0d0d0;
  padding-right: 0.4rem;
}
.float_box a {
  position: relative;
}
.float_box a:not(:last-child):after {
  content: '';
  position: absolute;
  width: 0.025rem;
  height: 1.4rem;
  background: url('img/b_line.png') no-repeat top center;
  background-size: 100% 100%;
  left: 0;
  top: 0.3rem;
}
.float_box .home_1 {
  float: right;
  display: block;
  width: 2.25rem;
  height: 2rem;
  background: url('img/home_1.png') no-repeat center center;
  background-size: 1.15rem 1.5rem;
}
.float_box .mine_1 {
  float: right;
  display: block;
  width: 2.25rem;
  height: 2rem;
  background: url('img/mine_1.png') no-repeat center center;
  background-size: 1.15rem 1.5rem;
}
.float_box .mine_1.new:before {
  content: '';
  position: absolute;
  width: 0.4rem;
  height: 0.4rem;
  background: url('img/new.png') no-repeat top center;
  background-size: 100% 100%;
  top: 0.25rem;
  right: 0.4rem;
  z-index: 1;
}
.float_box .attention_1 {
  float: right;
  display: block;
  width: 2.25rem;
  height: 2rem;
  background: url('img/attention_1.png') no-repeat center center;
  background-size: 1.15rem 1.5rem;
}
.float_box .shopping_car {
  float: right;
  display: block;
  width: 2.25rem;
  height: 2rem;
  background: url('img/shopping_car_1.png') no-repeat center center;
  background-size: 1.625rem 1.575rem;
}
</style>



// WEBPACK FOOTER //
// navBar.vue